import { UI_Anchor } from 'ui/components/1-atoms/Action/Anchor/Anchor';

export const AnchorFeature: React.FC<Content.Anchor> = ({ content }) => <UI_Anchor anchorName={content?.properties?.anchorName} />;
